import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';

import { PrintIcon } from '../../../icons';
import * as styles from './index.css';
import { trackClick } from './tracking';

export interface IPrintButtonProps {
  className?: string;

  openPrintModal(): void;
}

export class PrintButton extends React.PureComponent<IPrintButtonProps, {}> {
  public render() {
    return (
      <button {...mergeStyles([styles['button'], this.props.className])} onClick={this.handleClick} title="Печать">
        <PrintIcon />
      </button>
    );
  }

  private handleClick = () => {
    trackClick();
    this.props.openPrintModal();
  };
}
